/** CSS preview variant for a showcase game card (visual only; not authoritative metadata). */
export type GamePreviewKind = 'slot' | 'dice' | 'lightning-dice' | 'seahorse-race';

/** Maps a catalog game_id to its lobby preview style. Unknown ids use the slot preview. */
export function previewClassForGameId(gameId: string): GamePreviewKind {
  switch (gameId) {
    case 'dice':
      return 'dice';
    case 'lightning-dice':
      return 'lightning-dice';
    case 'seahorse-race':
      return 'seahorse-race';
    default:
      return 'slot';
  }
}
